import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Input } from "../components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { PageHeader, StageBadge } from "../components/common";
import { useData } from "../context/DataContext";
import { fmtDate } from "../lib/constants";

export default function Clients() {
  const { demandes, echanges, rdvs, missions } = useData();
  const navigate = useNavigate();
  const [q, setQ] = useState("");

  const rows = useMemo(() => demandes
    .filter((d) => `${d.entreprise} ${d.contact_nom}`.toLowerCase().includes(q.toLowerCase()))
    .map((d) => {
      const ex = echanges.filter((e) => e.demande_id === d.id).sort((a, b) => b.date.localeCompare(a.date));
      const next = rdvs.filter((r) => r.demande_id === d.id && !r.fait).sort((a, b) => a.date.localeCompare(b.date))[0];
      return { d, count: ex.length, last: ex[0], next, missions: missions.filter((m) => m.demande_id === d.id).length };
    })
    .sort((a, b) => (b.last?.date || "").localeCompare(a.last?.date || "")), [demandes, echanges, rdvs, missions, q]);

  return (
    <div data-testid="clients-page">
      <PageHeader eyebrow="Relation client" title="Clients & historique des échanges" description="Retrouvez chaque client, son dernier échange et sa prochaine action. Cliquez pour ouvrir l'historique complet." />
      <div className="relative mb-6 max-w-md"><Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[var(--kc-muted)]" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher un client…" className="bg-white pl-9" data-testid="search-clients-input" /></div>
      <div className="kc-card overflow-hidden" data-testid="clients-table">
        <Table>
          <TableHeader><TableRow>
            <TableHead>Client</TableHead><TableHead>Étape</TableHead><TableHead>Échanges</TableHead><TableHead>Dernier échange</TableHead><TableHead>Prochaine action</TableHead><TableHead>Missions</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {rows.map(({ d, count, last, next, missions: nm }) => (
              <TableRow key={d.id} className="cursor-pointer" onClick={() => navigate(`/demandes/${d.id}`)} data-testid={`client-row-${d.id}`}>
                <TableCell><p className="font-medium text-[var(--kc-navy)]">{d.entreprise}</p><p className="text-xs text-[var(--kc-muted)]">{d.contact_nom}</p></TableCell>
                <TableCell><StageBadge etape={d.etape} /></TableCell>
                <TableCell className="font-mono text-sm">{count}</TableCell>
                <TableCell className="max-w-xs">{last ? <><p className="text-xs text-[var(--kc-muted)]">{last.type} · {fmtDate(last.date)}</p><p className="truncate text-sm">{last.resume}</p></> : <span className="text-sm text-[var(--kc-muted)]">—</span>}</TableCell>
                <TableCell className="text-sm">{next ? <><p>{next.titre}</p><p className="text-xs text-[var(--kc-muted)]">{fmtDate(next.date, "d MMM · HH:mm")}</p></> : <span className="text-[var(--kc-muted)]">—</span>}</TableCell>
                <TableCell className="font-mono text-sm">{nm}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
